import { render, staticRenderFns } from "./advanceTradeReferencesSettings.vue?vue&type=template&id=43d11bea"
import script from "./advanceTradeReferencesSettings.vue?vue&type=script&lang=js"
export * from "./advanceTradeReferencesSettings.vue?vue&type=script&lang=js"
import style0 from "./advanceTradeReferencesSettings.vue?vue&type=style&index=0&id=43d11bea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports